import {useEffect} from 'react';
import {useParams, useSearchParams} from 'react-router-dom';

import {openPapasWebview} from '@zzng/common/scheme/digitaldocs';
import {closeWebView} from '@zzng/common/scheme/web';
import {captureException} from '@zzng/common/utils/matrix';
import {isReIssue} from '@zzng/common/utils/reIssue';

import {useCreatePapasTransaction} from '@/root/queries/recommend';

import PageLayout from '@/shared/components/PageLayout';
import useAdvancedNavigate from '@/shared/hooks/useAdvancedNavigate';
import {useStatusBarDimmedColor} from '@/shared/hooks/useStatusBarDimmedColor';

import {RecommendCodeUsingPapas} from '@/apps/root/constants/recommendCode';
import {ROUTES} from '@/apps/root/constants/routes';
import usePopup from '@/apps/root/hooks/usePopup';
import {getPapasErrorCode, isRecommendCodeUsingPapas} from '@/apps/root/utils/recommendCode';

const PapasBridgePage = () => {
  const {groupCode = ''} = useParams<{groupCode: string}>();
  const navigate = useAdvancedNavigate();
  const {createPapasTransactionMutation} = useCreatePapasTransaction();
  const {openPopup} = usePopup();
  const [searchParams] = useSearchParams();

  const title = isReIssue ? '재발급' : '발급';

  useStatusBarDimmedColor(true);

  useEffect(() => {
    if (!isRecommendCodeUsingPapas(groupCode)) {
      captureException(`디카롱 카드 ${title}: 정의되지 않은 파파스 에러 코드입니다. ${groupCode}`);
      navigate(ROUTES.SERVER_ERROR);
      return;
    }

    createPapasTransactionMutation.mutate(groupCode, {
      onSuccess: ({txId, papasUrl}, code: RecommendCodeUsingPapas) => {
        openPapasWebview({
          isCurrentWebviewClose: true,
          papasUrl,
          papasTxId: txId,
          papasReturnUrl: {
            url: `${location.origin}/issue/papas/progress`,
            params: {
              cardType: code,
              ...(isReIssue && {reissue: true}),
              t_src: searchParams.get('t_src'),
              t_ch: searchParams.get('t_ch'),
              t_obj: searchParams.get('t_obj')
            }
          }
        });
      },
      onError: (error) => {
        const errorCode = getPapasErrorCode(error);
        openPopup('PAPAS_ERROR', {errorCode, onSubmit: () => closeWebView()});
      }
    });
  }, []);

  return (
    <PageLayout tiara={false}>
      <div className="dimmed_g"></div>
      <div className="box_loading type2">
        <div className="inner_loading">
          <span className="ico_loading" aria-label="로딩중">
            <span></span>
            <span></span>
            <span></span>
          </span>
          <div aria-live="assertive">
            <strong className="tit_loading">{title} 준비 중</strong>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};
export default PapasBridgePage;
